class Accordion extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.accordion-heading');
    this.content = this.querySelector('.accordion-content');
    this.contentInside = this.querySelector('.accordion-content-inside');
    this.isOpen = this.dataset.open || false;

    window.addEventListener('resize', () => {
      this.defineMaxHeight();
    });

    window.addEventListener('load', () => {
      this.defineMaxHeight();
    });

    window.addEventListener('orientationchange', () => {
      this.defineMaxHeight();
    });

    this.header.addEventListener('click', () => {
      this.toggle();
    });
  }

  toggle() {
    // close all other accordions
    const accordions = document.querySelectorAll('accordion-item');
    accordions.forEach((accordion) => {
      if (accordion !== this && accordion.isOpen) {
        accordion.isOpen = false;
        accordion.classList.remove('open');
        accordion.dataset.open = false;
      }
    });

    this.isOpen = !this.isOpen;
    this.classList.toggle('open');
    this.dataset.open = this.isOpen;
  }

  defineMaxHeight() {
    this.maxHeight = this.contentInside.scrollHeight;
    this.style.setProperty('--max-height', this.maxHeight + 'px');
  }
}

customElements.define('accordion-item', Accordion);
